var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActiveBenifitIcon = function SvgActiveBenifitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#active-benifit-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.38 6.047c.174.18.262.269.277.376a.3.3 0 0 1-.001.104c-.018.107-.108.194-.287.369l-3.3 3.218c-.35.34-.525.511-.736.544a.7.7 0 0 1-.205 0c-.21-.033-.385-.203-.735-.544L4.631 8.396c-.18-.175-.269-.262-.287-.369a.3.3 0 0 1-.001-.104c.015-.107.103-.197.277-.376l.093-.095c.175-.18.262-.269.369-.287a.3.3 0 0 1 .104-.001c.107.015.197.102.376.277l1.46 1.423c.087.085.13.128.183.136a.2.2 0 0 0 .051 0c.053-.008.097-.05.184-.136l2.998-2.923c.18-.175.269-.262.376-.277a.3.3 0 0 1 .104.001c.107.018.194.108.369.287z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active-benifit-icon_svg__a",
    width: 12.655,
    height: 10.339,
    x: 1.673,
    y: 2.993,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6898_561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6898_561",
    result: "shape"
  })))));
};
export default SvgActiveBenifitIcon;